import {Link} from '@material-ui/core';
import isNull from 'lodash/isNull';
import {Link as RouterLink, useRouteMatch} from 'react-router-dom';

const NavigationLink = (props: INavigationLinkProps) => {
	const matchesSelf = useRouteMatch(props.to);

	if (!isNull(matchesSelf) && matchesSelf.isExact) {
		return null;
	}

	return (
		<Link component={RouterLink} underline="none" color="inherit" to={props.to} className={props.className}>
			{props.text.toUpperCase()}
		</Link>
	);
};

interface INavigationLinkProps {
	text: string;
	to: string;
	className?: string;
}

export default NavigationLink;
